import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/profile';
import { getProfile } from '../ducks/auth';
import * as api from '../services/api';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
import { load, loaded } from 'ducks/loading';


function* updProfile(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/updProfile', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(getProfile());
    }
    else {
      yield put(actions.updProfileErorr(true));
      toast.error('Error in update profile');
    }
    yield put(loaded());
  }
  catch (error) {
    yield put(actions.updProfileErorr(true));
  }
}

function* cPwd(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/cPwd', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.cPwdSuccess('success'));
      yield put(getProfile());
    }
    else if (res.status == 'not_found') {
      yield put(actions.cPwdSuccess('not_found'));
      toast.info(res.m);
    }
    else {
      yield put(actions.cPwdErorr(true));
      toast.error('Error in update password');
    }
    yield put(loaded());
  }
  catch (error) {
    yield put(actions.cPwdErorr(true));
  }
}

function* updProfileImg(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/updProfileImg', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(getProfile());
    }
    else {
      yield put(actions.updProfileImgErorr(true));
      toast.error('Error in update profile image');
    }
    yield put(loaded());
  }
  catch (error) {
    yield put(actions.updProfileImgErorr(true));
  }
}


export function* watchCPwd() {
  yield takeEvery(actions.C_PWD, cPwd);
}

export function* watchUpdProfile() {
  yield takeEvery(actions.UPD_PROFILE, updProfile);
}

export function* watchUpdProfileImg() {
  yield takeEvery(actions.UPD_PROFILE_IMG, updProfileImg);
}


export default function* rootSaga() {
  yield [
    fork(watchUpdProfile),
    fork(watchCPwd),
    fork(watchUpdProfileImg)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/profile.js